export default __webpack_public_path__ + "static/media/Chef.66525cf7.svg";